import { render, staticRenderFns } from "./ads-postpaid-payment-failure.vue?vue&type=template&id=3230b38a&scoped=true"
import script from "./ads-postpaid-payment-failure.vue?vue&type=script&lang=js"
export * from "./ads-postpaid-payment-failure.vue?vue&type=script&lang=js"
import style0 from "./ads-postpaid-payment-failure.vue?vue&type=style&index=0&id=3230b38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230b38a",
  null
  
)

export default component.exports